import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './custom.scss';
import App from './App';
import {ChakraProvider} from '@chakra-ui/react';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {BrowserRouter} from 'react-router';
import {AuthProvider} from './auth/AuthContext';
import {system} from './theme';
import {Toaster} from './components/ui/toaster';
import {version} from './env';

console.log(`Spot Drive Client ${version()} (${import.meta.env.MODE})`);

const googleClientId = import.meta.env.REACT_APP_GOOGLE_CLIENT_ID;
if (!googleClientId) {
    throw new Error('REACT_APP_GOOGLE_CLIENT_ID is not set. Copy .env.example to .env and fill it in.');
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            retry: 1,
        },
    },
});

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <GoogleOAuthProvider clientId={googleClientId}>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <ChakraProvider value={system}>
                        <BrowserRouter>
                            <App/>
                        </BrowserRouter>
                        <Toaster/>
                    </ChakraProvider>
                </AuthProvider>
            </QueryClientProvider>
        </GoogleOAuthProvider>
    </React.StrictMode>
);
